<template>
  <v-container>
    <h1>Site Info</h1>
    <v-row>
      <v-col>
        <h3>Global $App Object</h3>
        <tree-view
          :data="$app"
          :options="{
            rootObjectKey: '$app',
            maxDepth: 0,
          }"
        ></tree-view>
      </v-col>
    </v-row>
    <v-row
      ><v-col>
        <h3>Routes</h3>
        <!-- :data="$router.options.routes" -->
        <tree-view
          :data="routes"
          :options="{
            rootObjectKey: 'Routes',
            maxDepth: 0,
          }"
        ></tree-view> </v-col
    ></v-row>
    <v-row
      ><v-col>
        <h3>Store</h3>
        <tree-view
          :data="$store.state"
          :options="{
            rootObjectKey: 'State',
            maxDepth: 0,
          }"
        ></tree-view>
        <tree-view
          :data="$store._actions"
          :options="{
            rootObjectKey: 'Actions',
            maxDepth: 0,
          }"
        ></tree-view> </v-col
    ></v-row>
  </v-container>
</template>

<script>
import Vue from "vue";
import TreeView from "vue-json-tree-view";
Vue.use(TreeView);

export default {
  name: "SiteInfo",
  route: {
    name: "Site Info",
    path: "/site-info",
  },
  data() {
    return {
      treeOptions: {
        maxDepth: 1,
        rootObjectKey: "root",
        modifiable: false,
        link: false,
        limitRenderDepth: false,
      },
    };
  },
  computed: {
    app() {
      const app = this.$app;
      let options = this.options({
        rootObjectKey: "App Data ($app)",
      });

      return {
        data: app,
        options,
      };
    },
    routes() {
      let routes = this.$router.options.routes;
      let _routes = {};
      routes.forEach((item) => {
        _routes[item.path] = item;
      });
      return _routes;
    },
  },
  methods: {
    options(obj) {
      let options = Object.assign({}, this.treeOptions);
      return Object.assign(options, obj);
    },
  },
  mounted() {
    console.log("store", this.$store);
  },
};
</script>

<style>
.tree-view-item-root > div > div > span:first-child {
  font-size: 1rem;
}
</style>
